import React from 'react';
import clsx from 'clsx';
import { Button } from '@/components/ui/button';
import { Icon } from '../icon';
import Icons from '@/const/icons';
import { Typography } from '../typography';
import useModal from '@/hooks/useModal';
import { Options } from '@/components/ui/combobox';

interface Props {
	open: boolean;
	value: string;
	containerRef: any;
	filterOptions: Options[];
	clearAll?: () => void;
	setValue: (value?: string) => void;
	setOpen: (value: boolean) => void;
}

export const ModalFilter: React.FC<Props> = ({
	open,
	value,
	setOpen,
	setValue,
	containerRef,
	filterOptions,
	clearAll,
}) => {
	const { Modal, show, hide } = useModal();

	React.useEffect(() => {
		open ? show() : hide();
	}, [open]);

	return (
		<Modal
			withXButton
			title="Filter by"
			classNameCardContainer="min-w-[343px] bg-white"
		>
			<Typography type="semibold-14" className="text-left">
				Tasks
			</Typography>
			<div className={clsx('text-black')}>
				<div>
					<Button
						variant={'ghost'}
						className="font-normal flex justify-start items-center gap-2 h-12 px-0 w-full"
						onClick={() => {
							if (clearAll) {
								clearAll();
								setOpen(false);
							}
						}}
					>
						<Icon src={Icons.broom} className="!w-5 !h-5" />
						<Typography type={'regular-16'}>Clear All</Typography>
					</Button>

					{filterOptions.map((option, index) => {
						const isLastElement = filterOptions.length === index + 1;
						return (
							<button
								ref={isLastElement ? containerRef : null}
								key={`list-${option.value}-${index}`}
								// value={option.value}
								className={clsx(
									'w-full py-3 max-w-64 flex items-center gap-2 cursor-pointer'
									// classNameCommandItem
								)}
								onClick={() => {
									setValue(option.value === value ? '' : option.value);
									setOpen(false);
								}}
							>
								<div>{option.icon && option.icon}</div>
								<Typography
									type={'regular-16'}
									className="line-clamp-1 text-ellipsis"
								>
									{option.label}
								</Typography>
							</button>
						);
					})}
				</div>
			</div>
		</Modal>
	);
};
